module.exports = __webpack_public_path__ + "static/media/cw.bc7dcd42.svg";